import React from "react";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../../Redux/common/actions";
import {
  Box,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
} from "@mui/material";
import { IoMdCloseCircleOutline } from "react-icons/io";

export default function ZoomModal({ img }) {

  // Derieved variables
  const dispatch = useDispatch();
  const { showModal } = useSelector((state) => state.commonReducer);

  // Helper functions
  const handleClose = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: false, type: null, method: "Z", data: null },
    });
  };

  return (
    <>
      <Dialog
        open={showModal?.show && showModal?.method === "Z"}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding:'8px',
            backgroundColor: "rgba(240, 240, 251, 1)",
          },
        }}
      >
        <DialogContent
          sx={{
            width: "100%",
            backgroundColor: "rgba(240, 240, 251, 1)",
          }}
        >
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 0,
              right: 0,
              color: '#000',
            }}
          >
            <IoMdCloseCircleOutline />
          </IconButton>
          {/* <Grid
            p={2}
            sx={{ height: "350px", width: "100%", border: "1px solid black" }}
          >
            <Grid
              component={"img"}
              src={img}
              alt="question"
              sx={{ height: "auto", width: "100%" }}
            />
          </Grid> */}

          <Grid
          p={1}
          sx={{
          width: "100%",
          height: "80vh",          // 🔥 use viewport
          overflow: "auto",        // 🔥 allow scroll
          WebkitOverflowScrolling: "touch",
            }}
        >
          <Box
            sx={{
            display: "inline-block",
            transform: "scale(2)",  // 👈 DEFAULT mobile zoom (200%)
            transformOrigin: "top left",
          }}
        >
          <Box
            component="img"
            src={img}
            alt="question"
            sx={{
              width: "100%",
              height: "auto",
              userSelect: "none",
              pointerEvents: "none",
            }}
          />
        </Box>
        </Grid>

        </DialogContent>
      </Dialog>
    </>
  );
}
